import React from "react";
import Accordion from "react-bootstrap/Accordion";
import imageUrl from "utils/imageUrl";

function Faq() {
  return (
    <div className="faq__group">
      <h5 className="atr">Frequently asked questions</h5>

      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0" className="content__space">
          <Accordion.Header>
            <h5 className="accordion-header">
              <span className="icon_box">
                <img src={imageUrl("icons/message.png")} alt="ask" />
              </span>
              <button>What is Real Estate market?</button>
            </h5>
          </Accordion.Header>
          <Accordion.Body>
            <div className="accordion-body">
              <p>
                combined with a handful of model sentence structures, to
                generate Lorem Ipsum which looks reasonable. The generated Lorem
                Ipsum is therefore always free from repetition, injected humour,
                or
              </p>
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1" className="content__space">
          <Accordion.Header>
            <h5 className="accordion-header">
              <span className="icon_box">
                <img src={imageUrl("icons/message.png")} alt="Fund" />
              </span>
              <button>
                What are the benefits of investing in Web3 Real Estate?
              </button>
            </h5>
          </Accordion.Header>
          <Accordion.Body>
            <div className="accordion-body">
              <p>
                combined with a handful of model sentence structures, to
                generate Lorem Ipsum which looks reasonable. The generated Lorem
                Ipsum is therefore always free from repetition, injected humour,
                or
              </p>
            </div>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2" className="content__space">
          <Accordion.Header>
            <h5 className="accordion-header">
              <span className="icon_box">
                <img src={imageUrl("icons/message.png")} alt="Fund" />
              </span>
              <button>What makes Web3 Real Estate different?</button>
            </h5>
          </Accordion.Header>
          <Accordion.Body>
            <div className="accordion-body">
              <p>
                combined with a handful of model sentence structures, to
                generate Lorem Ipsum which looks reasonable. The generated Lorem
                Ipsum is therefore always free from repetition, injected humour,
                or
              </p>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}

export default Faq;
